import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';
import { GraphService } from 'src/app/services/graph.service';
import { SecurityService } from 'src/app/services/security.service';
import { SsoSecurityService } from 'src/app/services/sso-security.service';
import { UserService } from 'src/app/services/user.service';
import { UserData } from '../model/user-data';
import { UsersDataResponse } from '../model/users-data-response';

@Component({
    selector: 'app-approved-dialog',
    templateUrl: './approved-dialog.component.html',
    styleUrls: ['./approved-dialog.component.scss'],
    standalone: false
})
export class ApprovedDialogComponent implements OnInit {
  title = "";
  message = "";
  reauthForm: UntypedFormGroup;
  
  user:UsersDataResponse;
  userData:UserData;
  orderType:null;
  constructor(
    public dialogRef: MatDialogRef<ApprovedDialogComponent>,
    private fb: UntypedFormBuilder,

    @Inject(MAT_DIALOG_DATA) data,
    private userservice:UserService,
    private authService: MsalService,private graphservice:GraphService,private mainauthservice:SsoSecurityService) {
      this.dialogRef.disableClose = true;
      this.title = data.title;
    this.message = data.message;
    this.orderType=data.orderType;
    this.createForm();
  }

  close(): void {
    this.dialogRef.close(this.valid);
  }

  ngOnInit(): void {
    this.userservice.getCurrentUser().subscribe(data=>{
      this.user=data;
      this.userData=data.userData;
     
    })
    
  }
  approve() {
  this.validateUser();
  }

  createForm() {
    this.reauthForm = this.fb.group({
      upn: ['', Validators.required],



    });

  }
   valid = false;
   isLoading=true;
  async validateUser() {
    this.valid = false;
    this.message="";
    this.isLoading=false;
   let user:string= this.reauthForm.controls.upn.value;
    const loginRequest = {
      scopes: ["user.read"],
      // loginHint: this.userData.upn
      loginHint: user
    }
    if(this.user.userData.upn.toUpperCase()!==user.toUpperCase()){
      this.valid=false;
      this.message=this.userData.language=="EN"?"Invalid login":"Identifiant invalide"
      this.isLoading=true;
    }else{
     
    
   
     //let token=await this.getToken();
     this.graphservice.getProfile().then(u=>{
      if(u.toUpperCase()===user.toUpperCase()){

     
   //  })
 //   this.authService.ssoSilent(loginRequest).subscribe(data => {
      // this.graphservice.init(data.accessToken);
      // this.graphservice.getUserProfile(user).then(reauthuser => {
      //  console.log(data);
     
        this.valid = true;
        this.isLoading=true;
        this.close();
      
    } else{
      this.valid=false;
      this.message="Invalid login"
      this.isLoading=true;
    }
  
  },
      
    // (error: HttpErrorResponse) => {
    //   console.log(error.status)
    // })
    //},
    (error: InteractionRequiredAuthError) => {
      this.message=this.userData.language=="EN"?"Invalid login":"Identifiant invalide"
      this.isLoading=true;
      this.valid = false;
      console.log(error.errorMessage,error.errorCode)
    })

 }
  }


  async getToken(){
    let token = await this.mainauthservice.accessToken()
  }

}
